import type { Icon } from '@/types/icons';

import * as library from './library';
export const iconLibrary: Record<string, Icon> = library;

export * from './ui';
